export default class RadioControl {
  #ctrl: any;
  #value = null;

  constructor(
    controlWrapper: any,
    parameterMeta: any,
    finishedInteractionCallback: Function
  ) {
    this.#init(controlWrapper, parameterMeta, finishedInteractionCallback);
  }

  #init(
    controlWrapper: any,
    parameterMeta: any,
    finishedInteractionCallback: Function
  ) {
    let u_id = controlWrapper.parent().attr("class"); // Parameter name for checkbox id
    u_id = u_id.replace("parameters ", "");
    const that = this;
    const labelHTML = "<label>" + parameterMeta.label + ":</label>";

    $(controlWrapper).append(labelHTML);
    $(controlWrapper).append(
      `<fieldset class="control ${parameterMeta.name}"</fieldset>`
    );
    const fieldSet = $(controlWrapper).find(".control");

    let i = 0;
    parameterMeta.control.options.forEach((o: any) => {
      let labelradio = `<label for="${u_id + i}">${o.label}</label>`;
      let inputradio = `<input type="radio" name="${u_id}" id="${
        u_id + i
      }" value="${o.value}">`;
      fieldSet.append(labelradio + inputradio);
      i++;
    });
    console.log(parameterMeta);
    this.#value = parameterMeta.defaultvalue;

    // @ts-ignore
    this.#ctrl = fieldSet.children("input").checkboxradio({
      icon: false,
      create: function (event: any) {
        if ($(this).val() === parameterMeta.defaultvalue) {
          // @ts-ignore
          $(this).prop("checked", true).checkboxradio("refresh");
        }
      },
    });

    const f = function (e: any) {
      that.#value = $(e.currentTarget).val();

      finishedInteractionCallback();
    };

    fieldSet.children("input").on("change", f);
    this.#ctrl.on("change", f);
    fieldSet.data("public", this);
  }

  getValue() {
    return this.#value;
  }
}
